import { useQuery } from '@hooks/reactQuery';

import { getHistory2Fa } from '@api/userProfile';

import { HISTORY_2FA } from '@constants/queryKeys';

export const useQuery2FaHistory = () => {
	const {
		data: leftSeconds,
		isLoading: isLoadingHistory,
		isFetching: isFetchingHistory,
	} = useQuery<number>({
		queryKey: [HISTORY_2FA],
		queryFn: getHistory2Fa,
	});

	return {
		isLoadingHistory: isLoadingHistory || isFetchingHistory,
		leftSeconds,
	};
};
